// src/components/Step3.js
import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import ProgressMessage from './ProgressMessage';
import '../css/Step3.css';


const CategoryDBConversion = () => {
  const [statusMessage, setStatusMessage] = useState('대기중...');
  const [isConverting, setIsConverting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [animatedText , setAnimatedText] = useState('');

  const fullText = 'Korean DB => Japanese DB'; // Full text to animate

  // Effect to animate the text
  useEffect(() => {
    if (isConverting) {
      let currentIndex = 0;

      // Timer to animate text
      const timer = setInterval(() => {
        setAnimatedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;

        if (currentIndex === fullText.length) {
          currentIndex = 0; // Restart animation
        }
      }, 150); // Adjust speed here

      return () => clearInterval(timer); // Clean up on unmount or stop
    } else {
      setAnimatedText(fullText); // Reset text when not extracting
    }
  }, [isConverting]);

  const handleStartConvert =()=> {
    setIsConverting(true);
    setStatusMessage("Categories DB 변환 중...")

    axios.post('http://localhost:5000/convert-category/convert-db-categories')
      .then(response=>{
        setTimeout(()=> {
          translateCategoriesTable(); // 번역 잠시 중지
        },500)
      
      })
      .catch(error => { 
        console.log("Error During Conversion : ",error);
        setStatusMessage("카테고리 DB 변환중 오류가 발생했습니다. ");
        setIsConverting(false);
      })
  }
  const translateCategoriesTable =()=> {
    setIsConverting(true);
    setStatusMessage("Categories DB 번역 중...")

    axios.post('http://localhost:5000/convert-category/translate-db-categories')
      .then(response=>{
        setTimeout(()=> {
          setStatusMessage("카테고리 DB 번역 완료. ");
        },500)
        
        setIsConverting(false);
        setIsFinished(true);
      })
      .catch(error => { 
        console.log("Error During Conversion : ",error);
        setStatusMessage("카테고리 DB 변환중 오류가 발생했습니다. ");
        setIsConverting(false);
      })
  }

  return (
    <motion.div
      className="step-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h2>Category DB Conversion</h2>
			<p className={`animated-text ${isConverting ? 'extracting' : ''}`}>
        {animatedText}
      </p>
      <div className="conversion-container">
        <button 
          onClick={handleStartConvert} 
          className="convert-button" 
          disabled={isConverting}
        >
          Convert and Translate
        </button>
        <button 
          onClick={translateCategoriesTable} 
          className="convert-button" 
          disabled={isConverting}
        >
          Translate (TEMP)
        </button>
        <ProgressMessage message={statusMessage} />
        {isFinished && <Link to="/step4" className="next-button">Next</Link>}
      </div>
    </motion.div>
  );
};

export default CategoryDBConversion;
